import React from "react";
import { motion } from "framer-motion";
import logoTop from '../../assets/img/logo/loading-up.png';
import logoDown from '../../assets/img/logo/loading-down.png';

import './loading.css';

const LoadingScreen = () => {
    return (
      <div className="loading-container">
        {/* Top Half of the Logo */}
        <motion.div
          className="logo-part top-half"
          initial={{ y: 0 }}
          animate={{ y: -20 }}
          transition={{
            repeat: Infinity,
            repeatType: "reverse",
            duration: 0.9,
            ease: "easeInOut",
          }}
        >
          <img src={logoTop} alt="Logo Top Half" className="logo-image top" />
        </motion.div>
  
        {/* Bottom Half of the Logo */}
        <motion.div
          className="logo-part bottom-half"
          initial={{ y: 0 }}
          animate={{ y: 20 }}
          transition={{
            repeat: Infinity,
            repeatType: "reverse",
            duration: 0.9,
            ease: "easeInOut",
          }}
        >
          <img src={logoDown} alt="Logo Bottom Half" className="logo-image bottom" />
        </motion.div>
      </div>
    );
  };
  
  export default LoadingScreen;
